/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsReceivedConversationDetailsRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.reviews.received.conversation.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsReceivedConversationDetailsRoute);
